import { render, staticRenderFns } from "./tambahartikel.vue?vue&type=template&id=493035bf&"
import script from "./tambahartikel.vue?vue&type=script&lang=js&"
export * from "./tambahartikel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports